module.exports = __webpack_public_path__ + "static/media/side.a3815564.png";